module.exports = __webpack_public_path__ + "img/wrapbg8.568306b9.png";